import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { FileText, Pencil, Plus, Send, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import PageHeader from "@/components/PageHeader";
import TemplateDialog from "@/components/TemplateDialog";
import api, { errMsg, fmtDate, imageUrl } from "@/lib/api";

export default function Templates() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/templates").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const remove = async (t) => {
    if (!window.confirm(`Padam template "${t.name}"?`)) return;
    try { await api.delete(`/templates/${t.id}`); toast.success("Template dipadam"); load(); } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div>
      <PageHeader eyebrow="Template" title="Template post" desc="Simpan teks promosi yang kerap digunakan. Tekan “Guna” untuk terus buka dalam Tulis Post."
        action={<Button onClick={() => setEditing({})} data-testid="add-template-btn"><Plus className="mr-2 h-4 w-4" /> Template Baharu</Button>} />
      {items.length === 0 && (
        <div className="panel p-12 text-center" data-testid="templates-empty">
          <FileText className="mx-auto h-8 w-8 text-muted-foreground" />
          <p className="mt-3 text-sm text-muted-foreground">Belum ada template. Cipta satu, atau tekan “Simpan template” semasa menulis post.</p>
        </div>
      )}
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3" data-testid="templates-list">
        {items.map((t, i) => (
          <div key={t.id} className="panel fade-up flex flex-col p-5 transition-colors hover:border-primary/40" style={{ animationDelay: `${i * 40}ms` }} data-testid={`template-card-${t.id}`}>
            <div className="flex items-start gap-3">
              {t.image_id && <img src={imageUrl(t.image_id)} alt="" className="h-12 w-12 rounded-md border border-border object-cover" />}
              <div className="min-w-0 flex-1">
                <p className="truncate font-semibold">{t.name}</p>
                <p className="font-mono text-[11px] text-muted-foreground">{fmtDate(t.created_at)}</p>
              </div>
            </div>
            <p className="mt-3 line-clamp-4 flex-1 whitespace-pre-wrap text-sm leading-relaxed text-slate-300">{t.content}</p>
            <div className="mt-4 flex gap-2">
              <Button size="sm" onClick={() => navigate("/tulis", { state: { templateId: t.id } })} data-testid={`template-use-btn-${t.id}`}><Send className="mr-1.5 h-3.5 w-3.5" /> Guna</Button>
              <Button size="icon" variant="ghost" className="h-9 w-9" onClick={() => setEditing(t)} data-testid={`template-edit-btn-${t.id}`}><Pencil className="h-4 w-4" /></Button>
              <Button size="icon" variant="ghost" className="h-9 w-9 text-red-300" onClick={() => remove(t)} data-testid={`template-delete-btn-${t.id}`}><Trash2 className="h-4 w-4" /></Button>
            </div>
          </div>
        ))}
      </div>
      <TemplateDialog template={editing} onClose={() => setEditing(null)} onSaved={load} />
    </div>
  );
}
